import { Image } from '$partials/media';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
/**
 * @type {import('$types/components/partials/modules.d.ts').TwoImagesV2}
 */
const TwoImagesV2 = ({
    image1,
    image2,
    caption1,
    caption2
}) => {
    return (
        <div
            className='flex flex-col sm-flex-row width-100'>
            <figure className='col-12 sm-col-4 sm-mr5 md-mr6'>
                <Image
                    {...image1}
                    height={image1.croppedHeight}
                    width={image1.croppedWidth} />
                {caption1 && (
                    <figcaption className='mt4 mb7 sm-mb0 sm-mt3'>
                        <div
                            className='rich-text type-style-7'
                            dangerouslySetInnerHTML={{__html: caption1}}/>
                    </figcaption>
                )}
            </figure>
            <figure className='col-12 sm-col-9'>
                <Image
                    {...image2}
                    height={image2.croppedHeight}
                    width={image2.croppedWidth} />
                {caption2 && (
                    <figcaption className='mt4 sm-mt3'>
                        <div
                            className='rich-text type-style-7'
                            dangerouslySetInnerHTML={{__html: caption2}}/>
                    </figcaption>
                )}
            </figure>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default TwoImagesV2;
